import { render } from "./index.vue?vue&type=template&id=9938523a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9938523a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9938523a"

export default script